import React from 'react';
import { getStrings } from '@/helpers/utils';
import Information from './Components/Information';
import AccountWrapper from '../../../wrappers/AccountWrapper/AccountWrapper';

const TakeABreak: React.FC = () => {
  const [
    {
      Account: {
        TakeABreak: { pageTitle },
      },
    },
  ] = getStrings();

  return (
    <AccountWrapper pageTitle={pageTitle} pageHeader={pageTitle}>
      <Information />
    </AccountWrapper>
  );
};

export default TakeABreak;
